module.exports = __webpack_public_path__ + "static/chrome-fa28ff34cead5fc8bd81a8c98ffed2eb.svg";